<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Add New Scenario'"
  (nzOnCancel)="onCancelClick()"
>
  <ng-container *nzModalContent>
    <nz-progress [nzPercent]="currentProgress()" nzStrokeColor="#1890ff"></nz-progress>
    <div [@stepTransition]="currentStepIndex()" class="modal-content">
      @switch (currentStepIndex()) {
        @case (0) {
          <div class="step-content vertical-large">
            <div class="vertical">
              <h3>1. What's your scenario name?</h3>
              <input
                [disabled]="isAutoGenerateScenarioName"
                [(ngModel)]="scenarioName"
                nz-input
                [placeholder]="
                  isAutoGenerateScenarioName ? 'It will auto-generate based on your settings.' : 'Scenario Name'
                "
                nzSize="large"
              />
              <label nz-checkbox [(ngModel)]="isAutoGenerateScenarioName">Generate automatically later</label>
            </div>
          </div>
        }
        @case (1) {
          <div class="step-content vertical-large">
            <div class="vertical">
              <h3>2. What's your sales cycle and target call duration?</h3>
              <nz-segmented
                [nzSize]="'large'"
                [nzOptions]="salesCycleTitleList()"
                [(ngModel)]="currentSalesCycleIndex"
                (nzValueChange)="onCurrentSalesCycleChange($event)"
              ></nz-segmented>
            </div>

            <div class="vertical">
              <h3>Target Call Duration (1 to 60 mins)</h3>
              <nz-input-number-group [ngStyle]="{ width: '200px' }" style="width: 100%" nzAddOnAfter="Minutes">
                <nz-input-number
                  [nzStep]="1"
                  [nzMax]="60"
                  [nzMin]="1"
                  [(ngModel)]="targetCallDuration"
                ></nz-input-number>
              </nz-input-number-group>
            </div>
          </div>
        }
        @case (2) {
          <div class="step-content vertical no-gap">
            <h3 class="is-required">3. What's your product?</h3>
            @if (!enableAddProduct) {
              <div class="vertical no-gap" [@fadeInOut]>
                <nz-select class="select" [nzSize]="'large'" [(ngModel)]="productId">
                  @for (item of productList(); track $index) {
                    <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
                  }
                </nz-select>

                <nz-divider nzPlain nzText="or"></nz-divider>

                <button
                  class="center fit-content"
                  nz-button
                  nzType="default"
                  [nzLoading]="isLoading()"
                  (click)="onEnableAddProduct()"
                >
                  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
                  Add New Product
                </button>
              </div>
            } @else {
              <div [@fadeInOut] class="vertical-large">
                <div class="vertical">
                  <div class="field-name">Product Name</div>
                  <div class="horizontal">
                    <input
                      [disabled]="isAutoGenerateProductName"
                      [(ngModel)]="newProductName"
                      nz-input
                      [placeholder]="
                        isAutoGenerateProductName
                          ? 'It will auto-generate based on your product description.'
                          : 'Product Name'
                      "
                      nzSize="large"
                    />
                    <label [ngStyle]="{ width: '190px' }" nz-checkbox [(ngModel)]="isAutoGenerateProductName"
                      >Auto Generate</label
                    >
                  </div>
                </div>
                <div class="vertical">
                  <div class="field-name">Product Description</div>
                  <textarea
                    nz-input
                    placeholder="Product Description"
                    [(ngModel)]="newProductDescription"
                    [rows]="4"
                  ></textarea>
                </div>
                <button
                  class="fit-content right"
                  nz-button
                  nzType="primary"
                  [nzLoading]="isLoading()"
                  (click)="onAddNewProduct()"
                >
                  Save
                </button>
              </div>

              <nz-divider nzPlain nzText="or"></nz-divider>

              <button
                class="center fit-content"
                nz-button
                nzType="default"
                [nzLoading]="isLoading()"
                (click)="onEnableAddProduct()"
              >
                Choose Product
              </button>
            }
          </div>
        }
        @case (3) {
          <div class="step-content">
            <h3 class="is-required">4. Who is your AI customer?</h3>

            @if (createdResume) {
              <div class="horizontal">
                <app-profile-card-small [resume]="createdResume"></app-profile-card-small>
                <button nz-button nzType="default" nzSize="small" [nzLoading]="isLoading()" (click)="onViewEditClick()">
                  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
                  Edit
                </button>
              </div>
            } @else {
              <button nz-button nzType="default" [nzLoading]="isLoading()" (click)="onCreateCustomerClick()">
                Create an AI customer based on your product
              </button>
            }

            <nz-divider nzPlain nzText="or"></nz-divider>

            <div class="field-name">Choose an existing customer</div>
            <div class="horizontal">
              <nz-select class="select" [nzSize]="'large'" [(ngModel)]="resumeId" nzShowSearch [nzOptionHeightPx]="60">
                @for (item of resumeList(); track $index) {
                  <nz-option nzCustomContent [nzValue]="item.id" [nzLabel]="getResumeText(item)">
                    <app-profile-card-small [resume]="item"></app-profile-card-small>
                  </nz-option>
                }
              </nz-select>
            </div>
          </div>
        }
        @case (4) {
          <div class="step-content">
            <h3>5. Is this AI customer familiar with your product or service?</h3>
            <nz-segmented [nzOptions]="howFamiliarPersonaOptions" [(ngModel)]="howFamiliarPersonaIndex"></nz-segmented>

            <nz-divider nzPlain nzText="or"></nz-divider>

            <button nz-button nzType="primary" [nzLoading]="isLoading()" [disabled]="true">
              Upload Previous Meetings
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">lock</span>
            </button>
          </div>
        }
        @case (5) {
          <div class="step-content">
            <h3 class="is-required">6. What's the goal of this sales interaction?</h3>
            @if (!enableAddGoal) {
              <div class="vertical no-gap" [@fadeInOut]>
                <nz-select [nzSize]="'large'" class="select" [(ngModel)]="goalId">
                  @for (item of goalList(); track $index) {
                    <nz-option [nzValue]="item.id" [nzLabel]="item.title"></nz-option>
                  }
                </nz-select>

                <nz-divider nzPlain nzText="or"></nz-divider>

                <button
                  class="center fit-content"
                  nz-button
                  nzType="default"
                  [nzLoading]="isLoading()"
                  (click)="onEnableAddGoal()"
                >
                  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
                  Add New Goal
                </button>
              </div>
            } @else {
              <div [@fadeInOut] class="vertical-large">
                <div class="vertical">
                  <div class="field-name">Goal Name</div>
                  <div class="horizontal">
                    <input [(ngModel)]="newGoalName" nz-input [placeholder]="'Goal Name'" nzSize="large" />
                  </div>
                </div>
                <div class="vertical">
                  <div class="field-name">Goal Description</div>
                  <textarea
                    nz-input
                    placeholder="Goal Description"
                    [(ngModel)]="newGoalDescription"
                    [rows]="4"
                  ></textarea>
                </div>
                <button
                  class="fit-content right"
                  nz-button
                  nzType="primary"
                  [nzLoading]="isLoading()"
                  (click)="onAddNewGoal()"
                >
                  Save
                </button>
              </div>

              <nz-divider nzPlain nzText="or"></nz-divider>

              <button
                class="center fit-content"
                nz-button
                nzType="default"
                [nzLoading]="isLoading()"
                (click)="onEnableAddGoal()"
              >
                Choose Goal
              </button>
            }
          </div>
        }
        @case (6) {
          <div class="step-content vertical no-gap">
            <h3>7. What's your methodology?</h3>
            <nz-select [nzSize]="'large'" class="select" [(ngModel)]="methodologyId">
              @for (item of methodologyList(); track $index) {
                <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
              }
            </nz-select>
          </div>
        }
        @case (7) {
          <div class="step-content vertical no-gap">
            <h3>8. What's your emotional Objections?</h3>
            <div class="vertical">
              @for (emotionalItem of emotionalSelectList; track $index) {
                <label nz-checkbox [(ngModel)]="emotionalItem.isSelected">{{ emotionalItem.item.title }}</label>
              }
            </div>
          </div>
        }
        @case (8) {
          <div class="step-content vertical no-gap">
            <h3>9. What's your facts-based Objections?</h3>
            <div class="vertical">
              @for (factsItem of factSelectList; track $index) {
                <label nz-checkbox [(ngModel)]="factsItem.isSelected">{{ factsItem.item.title }}</label>
              }
            </div>
          </div>
        }
        @case (9) {
          <div class="step-content vertical no-gap">
            <h3>10. What's your instruction?</h3>
            <div class="vertical instruction-explain">
              <div>Need help setting up? Book a meeting, and we'll customize the instructions for you!</div>
              <button nz-button nzType="default" nzSize="small" class="fit-content" (click)="onBookMeetingClick()">
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">date_range</span>
                Book a meeting
              </button>
            </div>
            <textarea
              nz-input
              [placeholder]="instructionPlaceholder"
              [(ngModel)]="newInstruction"
              [rows]="7"
            ></textarea>
            <nz-divider nzPlain nzText="or select from Peak Mojo sample instructions"></nz-divider>

            <div class="horizontal">
              <button
                class="fit-content right"
                [nzSize]="'large'"
                nz-button
                nzType="default"
                [matTooltip]="'Click to apply'"
                [nzLoading]="isLoading()"
                (click)="onFillOutInstructionClick()"
              >
                Cold Calling Difficult Prospect
              </button>
            </div>
          </div>
        }
        <!-- @case (4) {
          <div class="step-content">
            <h3>5. What's the rubric you want to use for this sales interaction?</h3>
            <nz-select class="select" [nzSize]="'large'" [(ngModel)]="methodologyId">
              @for (item of methodologyList(); track $index) {
                <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
              }
            </nz-select>
          </div>
        } -->
        @default {
          <div class="vertical-large">
            <div class="vertical">
              <div class="field-name">Scenario Name</div>
              <div>{{ scenarioName }}</div>
            </div>

            <div class="vertical">
              <div class="field-name">You are going to talk to</div>
              <div class="horizontal">
                <app-profile-card-small [resume]="getResume()"></app-profile-card-small>
              </div>
            </div>

            <div class="vertical">
              <div class="field-name">Goal</div>
              <div class="horizontal">
                {{ getGoal()?.title }}
              </div>
            </div>

            <div class="vertical">
              <div class="field-name">Product</div>
              {{ getProduct()?.title }}
            </div>
          </div>
        }
      }
    </div>
  </ng-container>

  <div *nzModalFooter class="horizontal seperate full-width">
    <button nz-button nzType="default" [nzLoading]="isLoading()" (click)="onCancelClick()">Cancel</button>
    <div class="horizontal">
      @if (currentStepIndex() < totalSteps - 1) {
        <button
          nz-button
          nzType="default"
          [nzLoading]="isLoading()"
          [disabled]="currentStepIndex() === 0"
          (click)="onPreviousClick()"
        >
          Previous
        </button>
        <button nz-button nzType="primary" [nzLoading]="isLoading()" (click)="onNextClick()">Next</button>
      } @else if (currentStepIndex() === totalSteps - 1) {
        <button nz-button nzType="default" [nzLoading]="isLoading()" (click)="onPreviousClick()">Previous</button>
        <button
          nz-button
          nzType="primary"
          [nzLoading]="isLoading()"
          [disabled]="!this.goalId"
          (click)="onFinishClick()"
        >
          Finish
        </button>
      } @else if (currentStepIndex() === totalSteps) {
        <div class="horizontal-large">
          <button nz-button nzType="text" [nzLoading]="isLoading()" (click)="onCancelClick()">Call Later</button>
          <app-phone-call-button (click)="onStartCallClick()"> </app-phone-call-button>
        </div>
      }
    </div>
  </div>
</nz-modal>

<app-edit-resume [(isVisible)]="isEditResumeVisible" [resume]="createdResume!"></app-edit-resume>
